/* eslint-disable import/no-extraneous-dependencies */
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import SimpleBar from 'simplebar-react';
import styled, { css } from 'styled-components';

const UiScrollbar = styled(SimpleBar)`
  .simplebar-track {
    &.simplebar-vertical {
      width: ${(p) => (p.$compact ? 6 : 9)}px;

      ${(p) => (!p.$compact && css`
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 1px;
          height: 100%;
          background-color: ${props => (props.theme.formTheme === 'dark' ? 'rgba(255,255,255,0.112)' : 'rgba(51,51,51,0.112)')};
          opacity: 0;
          transition: opacity 0.15s cubic-bezier(.25,.1,.25,1), transform 0.15s cubic-bezier(.25,.1,.25,1);
        }

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: ${props => (props.theme.formTheme === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(51,51,51,0.02)')};
          opacity: 0;
          transition: opacity 0.15s cubic-bezier(.25,.1,.25,1), transform 0.15s cubic-bezier(.25,.1,.25,1);
        }

        &.simplebar-hover {
          transform: scaleX(1.5);

          &::before {
            opacity: 1;
            transform: scaleX(0.6667);
          }
          &::after {
            opacity: 1;
          }
        }
      `)}

      .simplebar-scrollbar {
        &::before {
          background-color: ${props => (props.theme.formTheme === 'dark' ? '#FFFFFF' : '#333333')};
        }

        &.simplebar-hover {
          &::before {
            ${(p) => (!p.$compact && css`
              transform: scaleX(1.5);
            `)}
          }
        }
      }
    }

    &.simplebar-horizontal {
      .simplebar-scrollbar {
        &::before {
          background-color: ${props => (props.theme.formTheme === 'dark' ? '#FFFFFF' : '#333333')};
        }
      }
    }
  }
`;

// $ prefix to prevent passing the prop down to SimpleBar - https://styled-components.com/docs/api#transient-props

const Scrollbar = forwardRef((props, ref) => {
  const { className, children, compact, ...rest } = props;

  return (
    <UiScrollbar ref={ref} className={classnames('ui-scrollbar', className)} $compact={compact} {...rest}>
      {children}
    </UiScrollbar>
  );
});

Scrollbar.displayName = 'Scrollbar';

Scrollbar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  compact: PropTypes.bool,
};

Scrollbar.defaultProps = {
  compact: true,
};

export default Scrollbar;
